module.exports = __webpack_public_path__ + "assets/img/is.c180ed52.png";